import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

const menuItems = [
  { label: '인사말', href: '/greeting', active: false },
  { label: '객실안내', href: '/#rooms', active: false },
  { label: '부대시설', href: '/facilities', active: true },
  { label: '오시는 길', href: '/#contact', active: false },
];

const facilityData = [
  {
    id: 'sauna',
    nameEn: 'SAUNA',
    nameKo: '사우나',
    icon: 'ri-drop-line',
    color: 'text-teal-600',
    bg: 'bg-teal-50',
    desc: '호텔 내 사우나 시설을 운영합니다. 여행의 피로를 말끔히 풀어드리는 힐링 공간입니다. 투숙객은 할인된 가격으로 이용 가능합니다.',
    details: [
      { label: '운영시간', value: '06:00 ~ 22:00' },
      { label: '이용요금', value: '투숙객 할인 적용' },
      { label: '위치', value: '호텔 내 지하 1층' },
    ],
    imgs: [
      'http://www.youngbinhotel.com/img_up/shop_pds/nbkorea/build/option/m_icon1155858726611574176173.png',
    ],
    mainImg: 'https://storage.readdy-site.link/project_files/f1a4733f-f142-44b4-9a4b-319ee3c3a442/cb60a4a9-6ca6-43d8-baaa-6dc3485c0b75_ea1078421a234494bb479e3c08de5fad.png?v=b17dfe2b55764c2a1b725ae8ac514d7d',
  },
  {
    id: 'parking',
    nameEn: 'PARKING',
    nameKo: '주차장',
    icon: 'ri-car-line',
    color: 'text-orange-600',
    bg: 'bg-orange-50',
    desc: '호텔 인근 주차 공간을 제공합니다. 차량 이용 고객분들께서는 체크인 시 프런트에 문의해 주시기 바랍니다.',
    details: [
      { label: '운영시간', value: '24시간' },
      { label: '이용요금', value: '별도 문의' },
      { label: '위치', value: '호텔 인근' },
    ],
    imgs: [],
    mainImg: 'https://storage.readdy-site.link/project_files/f1a4733f-f142-44b4-9a4b-319ee3c3a442/4b830b96-2f05-4f14-b322-73fa6f7b2141_expedia_group-2321711-31f9ed-536004.jpg?v=16a7167a5175e2f397d074eda5f17a02',
  },
  {
    id: 'wifi',
    nameEn: 'FREE WI-FI',
    nameKo: '무료 와이파이',
    icon: 'ri-wifi-line',
    color: 'text-sky-600',
    bg: 'bg-sky-50',
    desc: '전 객실 및 공용 공간에서 무료 고속 와이파이를 이용하실 수 있습니다. 별도 비밀번호 없이 자동 연결됩니다.',
    details: [
      { label: '제공범위', value: '전 객실 · 공용공간' },
      { label: '이용요금', value: '무료' },
      { label: '속도', value: '고속 인터넷' },
    ],
    imgs: [],
    mainImg: 'https://public.readdy.ai/ai/img_res/7e76d42e9a0b1d1a04f7f252d7661ebf.jpg',
  },
  {
    id: 'concierge',
    nameEn: '24H CONCIERGE',
    nameKo: '24시간 컨시어지',
    icon: 'ri-customer-service-2-line',
    color: 'text-rose-600',
    bg: 'bg-rose-50',
    desc: '24시간 365일 프런트 데스크를 운영합니다. 관광 정보, 교통 안내, 짐 보관 등 모든 문의에 친절하게 응대해 드립니다.',
    details: [
      { label: '운영시간', value: '24시간 365일' },
      { label: '서비스', value: '관광안내 · 짐보관 · 교통안내' },
      { label: '언어', value: '한국어 · 영어' },
    ],
    imgs: [],
    mainImg: 'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/61169bea203fb1408680167274008085.png',
  },
  {
    id: 'morning-call',
    nameEn: 'MORNING CALL',
    nameKo: '모닝콜',
    icon: 'ri-alarm-line',
    color: 'text-amber-600',
    bg: 'bg-amber-50',
    desc: '프런트에 원하시는 시간을 말씀해 주시면 정확한 시간에 모닝콜 서비스를 제공해 드립니다. 중요한 일정이 있으신 분들께 특히 추천드립니다.',
    details: [
      { label: '신청방법', value: '프런트 직접 요청' },
      { label: '이용요금', value: '무료' },
      { label: '운영시간', value: '24시간' },
    ],
    imgs: [],
    mainImg: 'https://readdy.ai/api/search-image?query=cozy%20hotel%20bedroom%20in%20early%20morning%20with%20soft%20golden%20sunrise%20light%20through%20sheer%20curtains%2C%20alarm%20clock%20on%20bedside%20table%20showing%20early%20morning%20time%2C%20neatly%20made%20white%20bed%20with%20crisp%20linens%2C%20warm%20peaceful%20atmosphere%2C%20gentle%20morning%20glow%2C%20comfortable%20and%20serene%20hotel%20room%20interior&width=800&height=600&seq=youngbin-morningcall-facility&orientation=landscape',
  },
  {
    id: 'security',
    nameEn: 'SECURITY',
    nameKo: '보안 시스템',
    icon: 'ri-shield-check-line',
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
    desc: 'CCTV 및 전자 도어락 시스템으로 24시간 보안을 유지합니다. 안전하고 편안한 숙박 환경을 제공해 드립니다.',
    details: [
      { label: '시스템', value: 'CCTV · 전자 도어락' },
      { label: '운영', value: '24시간 모니터링' },
      { label: '안전', value: '투숙객 전용 층 관리' },
    ],
    imgs: [],
    mainImg: 'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/2a7d5f5c5832307f7d1f8d2f4dcf3215.png',
  },
];

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const facilitiesSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${SITE_URL}/facilities`,
  url: `${SITE_URL}/facilities`,
  name: '부대시설 | 영빈호텔',
  description: '영빈호텔 부대시설 안내. 사우나, 주차장, 무료 와이파이, 24시간 컨시어지, 모닝콜, 보안 시스템 등 다양한 편의시설을 제공합니다.',
  isPartOf: { '@id': `${SITE_URL}/#website` },
  about: { '@id': `${SITE_URL}/#hotel` },
};

const FacilitiesPage = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = '부대시설 | 영빈호텔 YOUNGBIN HOTEL';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', '영빈호텔 부대시설 안내. 사우나, 주차장, 무료 와이파이, 24시간 컨시어지, 모닝콜, 보안 시스템 등 다양한 편의시설을 제공합니다.');
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-facilities';
    script.textContent = JSON.stringify(facilitiesSchema);
    document.head.appendChild(script);
    return () => {
      document.title = '영빈호텔 | YOUNGBIN HOTEL';
      if (metaDesc) metaDesc.setAttribute('content', '서울 중구 동대문 영빈호텔. 동대문 쇼핑상가 도보 10분, 사우나·무료와이파이·24시간 컨시어지 제공. TEL: 02-2277-1141');
      const el = document.getElementById('schema-facilities');
      if (el) el.remove();
    };
  }, []);

  const current = facilityData[active];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Sub Header */}
      <div className="pt-20 bg-stone-800">
        <div className="max-w-7xl mx-auto px-6 py-10">
          <p className="text-amber-400 text-xs tracking-[0.3em] uppercase mb-2">ABOUT HOTEL</p>
          <h1 className="text-3xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
            부대시설
          </h1>
        </div>
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex gap-0 flex-wrap">
              {menuItems.map((item) => (
                <Link
                  key={item.label}
                  to={item.href}
                  className={`px-6 py-4 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer border-b-2 ${
                    item.active
                      ? 'border-amber-400 text-amber-400'
                      : 'border-transparent text-white/60 hover:text-white hover:border-white/40'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-6 py-20">

        {/* Section Title */}
        <div className="text-center mb-14">
          <p className="text-amber-700 text-xs tracking-[0.3em] uppercase mb-3">FACILITIES &amp; SERVICES</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            부대시설 안내
          </h2>
          <p className="text-gray-500 text-sm">영빈호텔이 제공하는 다양한 편의시설과 서비스를 경험해 보세요</p>
        </div>

        {/* Facility Tab Buttons */}
        <div className="grid grid-cols-3 sm:grid-cols-6 gap-4 mb-12">
          {facilityData.map((fac, idx) => (
            <button
              key={fac.id}
              onClick={() => setActive(idx)}
              className={`flex flex-col items-center text-center p-4 rounded-xl border-2 transition-all duration-300 cursor-pointer ${
                active === idx
                  ? 'border-amber-500 bg-white'
                  : 'border-transparent bg-stone-50 hover:border-amber-200 hover:bg-white'
              }`}
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-full mb-3 ${active === idx ? fac.bg : 'bg-stone-100'}`}>
                <i className={`${fac.icon} text-2xl ${active === idx ? fac.color : 'text-gray-400'}`} />
              </div>
              <p className={`text-xs font-semibold leading-tight ${active === idx ? 'text-amber-800' : 'text-gray-600'}`}>
                {fac.nameKo}
              </p>
            </button>
          ))}
        </div>

        {/* Facility Detail */}
        <div className="flex flex-col lg:flex-row gap-0 items-stretch bg-white rounded-2xl overflow-hidden border border-stone-100">
          {/* Image */}
          <div className="w-full lg:w-1/2 h-72 lg:h-auto min-h-[320px] overflow-hidden bg-stone-100 flex items-center justify-center">
            <img
              src={current.mainImg}
              alt={current.nameKo}
              className="w-full h-full object-cover object-top transition-all duration-500"
              onError={(e) => {
                const target = e.currentTarget;
                target.style.display = 'none';
                const parent = target.parentElement;
                if (parent) {
                  parent.innerHTML = `<div class="flex flex-col items-center justify-center w-full h-full gap-4"><div class="w-20 h-20 flex items-center justify-center rounded-full bg-stone-200"><i class="${current.icon} text-4xl text-stone-400"></i></div><p class="text-stone-400 text-sm">${current.nameKo}</p></div>`;
                }
              }}
            />
          </div>

          {/* Info */}
          <div className="w-full lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center">
            <div className="flex items-center gap-4 mb-6">
              <div className={`w-14 h-14 flex items-center justify-center rounded-full ${current.bg}`}>
                <i className={`${current.icon} text-2xl ${current.color}`} />
              </div>
              <div>
                <p className="text-xs text-amber-700 tracking-widest uppercase mb-0.5">{current.nameEn}</p>
                <h3 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {current.nameKo}
                </h3>
              </div>
            </div>

            <p className="text-gray-500 text-sm leading-relaxed mb-8">{current.desc}</p>

            {/* Detail Info */}
            <div className="space-y-3 mb-8">
              {current.details.map((d) => (
                <div key={d.label} className="flex items-center gap-4 py-3 border-b border-stone-100">
                  <span className="text-xs text-gray-400 w-24 shrink-0">{d.label}</span>
                  <span className="text-sm font-medium text-gray-800">{d.value}</span>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3 pt-2">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-phone-line text-amber-700 text-lg" />
              </div>
              <a
                href="tel:0222771141"
                className="text-amber-700 text-sm font-medium hover:text-amber-800 cursor-pointer whitespace-nowrap"
              >
                문의: 02) 2277-1141~4
              </a>
            </div>
          </div>
        </div>

        {/* All Facilities Grid */}
        <div className="mt-20">
          <h3 className="text-xl font-bold text-gray-900 mb-8 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
            전체 시설 한눈에 보기
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {facilityData.map((fac, idx) => (
              <button
                key={fac.id}
                onClick={() => { setActive(idx); window.scrollTo({ top: 300, behavior: 'smooth' }); }}
                className="flex items-start gap-4 p-5 bg-stone-50 rounded-xl hover:bg-amber-50 transition-colors cursor-pointer text-left group"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-full shrink-0 ${fac.bg}`}>
                  <i className={`${fac.icon} text-xl ${fac.color}`} />
                </div>
                <div>
                  <p className="text-xs text-amber-700 tracking-wide uppercase mb-0.5">{fac.nameEn}</p>
                  <h4 className="text-sm font-bold text-gray-900 mb-1 group-hover:text-amber-800 transition-colors">{fac.nameKo}</h4>
                  <p className="text-xs text-gray-500 leading-relaxed line-clamp-2">{fac.desc}</p>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <Link
            to="/#reservation"
            className="inline-block px-10 py-3.5 bg-amber-700 text-white rounded-full text-sm font-semibold hover:bg-amber-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            실시간 예약하기
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FacilitiesPage;
